import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Spinner from "./Spinner";

const MUS_TEST = 52;

function SessionExpired() {
  const { codemp } = useSelector(state => state.adminReducer.login);
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("url");
    localStorage.removeItem("test");
    const urlRedirect = codemp === MUS_TEST ?
      'https://test-seguros.emusimundo.com:9002/webapi/platformWeb/cotizar/2ggGvy'
      : 'https://seguros.emusimundo.com/webapi/platformWeb/cotizar/uUnX0N'
    const tiempoEspera = 3000;
    const redireccionar = () => {
      window.location.replace(urlRedirect);
    };

    const timer = setTimeout(redireccionar, tiempoEspera);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="calc(100vh - 200px)"
        sx={{ flexDirection: { xs: 'column', sm: 'row' } }}
        color="ed1c24"
      >
        <Typography marginLeft={2} style={{ color: "black", fontFamily: 'Roboto' }}>Tu sesión ha caducado. Aguardá un instante por favor.</Typography>
      </Box>
      <Spinner />
    </>
  );
}

export default SessionExpired;